<template>
    <div>
        <div style="width: 100%;height: 500px;" id="chart-container"></div>
        <!-- <button id="download-btn">下载图表</button> -->
    </div>
</template>
<script>
import * as echarts from "echarts";
import Http from "../apis/teach";
export default {

    data(){
        return{

        }
    },

    activated() {
        // 在组件激活时绑定点击事件
        const downloadBtn = document.getElementById('download-btn');
        if (downloadBtn) {
            downloadBtn.addEventListener('click', () => {
                console.log(11)
                if (this.myChart) {
                    const imgData = this.myChart.getDataURL({
                        pixelRatio: 2,
                        backgroundColor: '#fff'
                    });
                    const link = document.createElement('a');
                    link.href = imgData;
                    link.download = 'chart.png';
                    link.click();
                }
            });
        }
    },
    methods:{
        getChartData(trem,plan_id){
            var params = {}
            params.trem = trem
            params.plan_id = plan_id
            Http.getChartsData(params).then((res) => {
                this.chart(res.data.key,res.data.value)
            });
        },
        chart(key,value){
            var dom = document.getElementById('chart-container');
            var myChart = echarts.init(dom, null, {
                renderer: 'canvas',
                useDirtyRect: false
            });
  
            var option;

            option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: key
                },
                yAxis: {
                    type: 'value',
                    min: 0, // 设置 y 轴最小值
                    max: 50, // 设置 y 轴最大值
                    interval: 50, // 设置刻度间隔
                },
                series: [
                    {
                    data: value,
                    type: 'bar'
                    }
                ]
            };


            if (option && typeof option === 'object') {
                myChart.setOption(option);
            }

            window.addEventListener('resize', myChart.resize);
        }
    }
}
</script>